import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  Select,
  format_date,
  GET,
  PUT,
  UPLOAD,
  t,
  can,
} from "../../components/CustomComponent.js";
import {
  EMPTY_GROUP,
  MEDIA_KINDS,
  MEDIA_TONES,
  HERO_POSITIONS,
  HERO_INTERVALS,
  ADMIN_ICON,
  clone,
  ordered,
  moveItem,
  nextSort,
  newUid,
} from "../../components/homepage_option.js";
import HomeMedia from "../homepage/components/HomeMedia.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/property_type.css";
import "../../assets/css/home_manage.css";

/* ============================================================================
 * จัดการหน้าแรก › ภาพพื้นหลัง  (/ad/home/hero)
 *
 * ภาพใหญ่ด้านบนสุดของหน้าเว็บลูกค้า ใส่ได้หลายภาพแล้วสไลด์เปลี่ยนไปทีละภาพ
 * เรื่อย ๆ — ที่นี่คุมว่ามีภาพอะไรบ้าง เรียงลำดับยังไง จุดโฟกัสของรูป และ
 * เปลี่ยนภาพทุกกี่วินาที ปรับแล้วเห็นผลทันทีที่กล่องพรีวิวด้านขวา
 *
 * ข้อมูลอ่าน/บันทึกผ่าน API จริง
 *   GET  admin/homepage/hero
 *   PUT  admin/homepage/hero   (ส่ง { setting, slides })
 * บันทึกแบบแทนที่ทั้งชุด — จัดลำดับ/เปิด-ปิดในหน้าจอจนพอใจแล้วค่อยกดบันทึกครั้งเดียว
 * ========================================================================== */

const EMPTY_FORM = {
  name: "",
  src: "",
  kind: "house",
  tone: 1,
  position: "center 42%",
  is_active: true,
};

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

export default class HomeHeroSetting extends Component {
  constructor(props) {
    super(props);
    const hero = clone(EMPTY_GROUP.hero);
    this.state = {
      setting: hero.setting,
      slides: hero.slides,
      saved: clone(hero),

      preview: 0, // ภาพที่กำลังโชว์ในกล่องพรีวิว
      /* ย่อรายการเพื่อดูตัวอย่างหน้าเว็บเต็มความกว้าง — พรีวิวคอลัมน์แคบเห็นแค่พอเดาได้
         ย่อแล้วกล่องพรีวิวจะกางเต็มแถวและภาพสูงขึ้น เห็นภาพจริงใกล้เคียงหน้าเว็บ */
      list_open: true,
      modal_form: false,
      edit_uid: "", // ว่าง = โหมดเพิ่มภาพใหม่
      form: { ...EMPTY_FORM },
      updated_at: "",
      updated_by: "",
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
    this.startPreview();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  /* โหลดเนื้อหากลุ่มนี้จากฐานข้อมูล — เรียกทั้งตอนเปิดหน้าและหลังบันทึกสำเร็จ
     เพื่อให้ uid ของรายการที่เพิ่งสร้างตรงกับฝั่ง server */
  Get = async () => {
    loading(true);
    const result = await GET("admin/homepage/hero", {});
    loading(false);
    if (result?.status && result.data) this.Apply(result.data);
  };

  Apply = (data) =>
    this.setState({
      setting: data.setting,
      slides: data.slides || [],
      saved: clone({ setting: data.setting, slides: data.slides || [] }),
      updated_at: data.updated_at || "",
      updated_by: data.updated_by || "",
    });

  /* พรีวิวหมุนภาพตามจังหวะที่ตั้งไว้ เพื่อให้เห็นภาพเดียวกับหน้าเว็บจริง */
  startPreview = () => {
    clearInterval(this.timer);
    const seconds = Math.max(2, Number(this.state.setting.interval) || 6);
    this.timer = setInterval(() => {
      const total = this.activeSlides().length;
      if (total > 1 && this.state.setting.autoplay) this.setState((prev) => ({ preview: (prev.preview + 1) % total }));
    }, seconds * 1000);
  };

  activeSlides = () => ordered(this.state.slides).filter((item) => item.is_active);

  isDirty = () =>
    JSON.stringify({ setting: this.state.setting, slides: this.state.slides }) !== JSON.stringify(this.state.saved);

  ToggleList = () => this.setState((prev) => ({ list_open: !prev.list_open }));

  setSetting = (patch) => this.setState((prev) => ({ setting: { ...prev.setting, ...patch } }), this.startPreview);

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* ---------------------------------------------------- เปิดฟอร์ม เพิ่ม/แก้ */
  OpenCreate = () => this.setState({ modal_form: true, edit_uid: "", form: { ...EMPTY_FORM } });

  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      edit_uid: item.uid,
      form: {
        name: item.name || "",
        src: item.src || "",
        kind: item.kind || "house",
        tone: item.tone ?? 1,
        position: item.position || "center 42%",
        is_active: !!item.is_active,
      },
    });

  CloseForm = () => this.setState({ modal_form: false });

  /* อัปโหลดขึ้น storage ทันทีแล้วเก็บเป็น URL — ไม่เก็บ base64 ลงฐานข้อมูล
     เพราะรูปหนึ่งใบกินหลายเมกะไบต์ และทำให้ payload ตอนบันทึกใหญ่เกินจำเป็น */
  PickImage = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = ""; // เลือกไฟล์เดิมซ้ำได้
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return alert("", "warning", t("warning"), t("home_verify_image_size"));

    loading(true);
    const result = await UPLOAD(file, { folder: "homepage/hero" });
    loading(false);

    if (!result?.status || !result.data?.file_path) {
      return alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    this.setForm({ src: result.data.file_path });
  };

  /* ------------------------------------------------------ บันทึกภาพในฟอร์ม */
  SaveSlide = () => {
    const { form, edit_uid } = this.state;
    if (!form.name.trim()) return alert("", "warning", t("warning"), t("home_verify_slide_name"));

    const payload = {
      name: form.name.trim(),
      src: form.src,
      kind: form.kind,
      tone: Number(form.tone),
      position: form.position,
      is_active: form.is_active,
    };

    this.setState((prev) => ({
      slides: edit_uid
        ? prev.slides.map((row) => (row.uid === edit_uid ? { ...row, ...payload } : row))
        : [...prev.slides, { ...payload, uid: newUid("hs"), sort: nextSort(prev.slides) }],
      modal_form: false,
      preview: 0,
    }));
  };

  Move = (item, step) => this.setState((prev) => ({ slides: moveItem(prev.slides, item.uid, step), preview: 0 }));

  ToggleActive = (item) =>
    this.setState((prev) => ({
      slides: prev.slides.map((row) => (row.uid === item.uid ? { ...row, is_active: !row.is_active } : row)),
      preview: 0,
    }));

  Delete = async (item) => {
    if (!(await alert("", "warning", t("delete_item"), `${t("home_delete_slide_desc")}\n${item.name}`, t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ slides: prev.slides.filter((row) => row.uid !== item.uid), preview: 0 }));
  };

  /* ------------------------------------------------------------ บันทึก/คืนค่า */
  Save = async () => {
    const { slides } = this.state;
    if (!slides.some((item) => item.is_active)) return alert("", "warning", t("warning"), t("home_verify_slide_active"));
    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT("admin/homepage/hero", { setting: this.state.setting, slides });
    loading(false);
    if (!result?.status) return;

    this.Apply(result.data);
    alert("", "success", t("success"), t("home_save_done"));
  };

  Reset = async () => {
    if (!this.isDirty()) return;
    if (!(await alert("", "warning", t("reset_changes"), t("discard_changes_confirm"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ setting: clone(prev.saved.setting), slides: clone(prev.saved.slides), preview: 0 }), this.startPreview);
  };

  /* ============================================== render : รายการภาพพื้นหลัง */
  renderList = () => {
    const list = ordered(this.state.slides);
    const active = list.filter((item) => item.is_active).length;
    const dirty = this.isDirty();

    return (
      <div className="prop-card prop-in">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_hero_list_title")}
          </span>
          <div className="hmg-sum">
            <span className="ppl-pill ppl-pill--ghost">
              {list.length} {t("home_unit_image")}
            </span>
            <span className="ppl-pill ppl-pill--on">
              <span className="ppl-pill__dot" />
              {active} {t("active")}
            </span>
            {can("homepage.update") && (
              <button type="button" className="prop-btn prop-btn--ghost" onClick={this.OpenCreate}>
                <span className="icon text-12">{ADMIN_ICON.plus}</span>
                {t("home_add_image")}
              </button>
            )}
            {/* ปุ่มย่อ เป็นแค่มุมมอง ไม่ใช่การแก้ข้อมูล คนที่ดูอย่างเดียวก็กดได้ */}
            <button type="button" className="prop-btn prop-btn--ghost" title={t("home_collapse_hint")} onClick={this.ToggleList}>
              <span className="icon text-12">{ADMIN_ICON.chevron_left}</span>
              {t("collapse")}
            </button>
          </div>
        </div>

        {/* จังหวะการเปลี่ยนภาพ */}
        <div className="p-4 pb-0">
          <div className="set-row mb-3">
            <div className="min-w-0">
              <div className="set-row__title">{t("home_hero_autoplay")}</div>
              <div className="set-row__desc">{t("home_hero_autoplay_desc")}</div>
            </div>
            <label className="ppl-switch">
              <input
                type="checkbox"
                checked={this.state.setting.autoplay}
                onChange={(e) => this.setSetting({ autoplay: e.target.checked })}
              />
              <span className="ppl-switch__track" />
            </label>
          </div>

          <div style={{ maxWidth: "260px" }}>
            <label className="prop-label">{t("home_hero_interval")}</label>
            <Select
              className="prop-field prop-select"
              default={false}
              placeholder={t("select")}
              value={String(this.state.setting.interval)}
              options={HERO_INTERVALS.map((item) => ({ value: item.value, label: `${item.label} ${t("home_unit_second")}` }))}
              onChange={(value) => value && this.setSetting({ interval: Number(value) })}
            />
            <div className="ppl-sub mt-1">{t("home_hero_interval_hint")}</div>
          </div>
        </div>

        <div className="hmg-list mt-3">
          {list.map((item, index) => (
            <div className={`hmg-row ${item.is_active ? "" : "is-off"}`} key={item.uid}>
              {/* ลำดับ + ปุ่มเลื่อน */}
              <div className="d-flex align-items-center gap-2">
                <span className="pty-rank">{index + 1}</span>
                <div className="pty-order">
                  <button
                    type="button"
                    className="pty-order__btn icon"
                    title={t("ptype_move_up")}
                    disabled={index === 0}
                    onClick={() => this.Move(item, -1)}
                  >
                    {ADMIN_ICON.up}
                  </button>
                  <button
                    type="button"
                    className="pty-order__btn icon"
                    title={t("ptype_move_down")}
                    disabled={index === list.length - 1}
                    onClick={() => this.Move(item, 1)}
                  >
                    {ADMIN_ICON.down}
                  </button>
                </div>
              </div>

              <div className="hmg-thumb">
                {item.src ? <img src={item.src} alt={item.name} /> : <HomeMedia kind={item.kind} tone={item.tone} ratio={0.66} alt={item.name} />}
                <span className="hmg-thumb__no">{index + 1}</span>
              </div>

              <div className="hmg-row__body">
                <div className="hmg-row__title">
                  <span>{item.name}</span>
                </div>
                <div className="hmg-row__meta">
                  <span className="hmg-tag">
                    <span className="icon text-10">{item.src ? ADMIN_ICON.photo : ADMIN_ICON.image}</span>
                    {item.src ? t("home_source_upload") : t("home_source_scene")}
                  </span>
                  {/* ป้ายรายละเอียด : ข้ามไปถ้าไม่มีค่าที่ตรงกับตัวเลือก จะได้ไม่เหลือป้ายเปล่า */}
                  {!item.src && !!MEDIA_KINDS.find((k) => k.value === item.kind) && (
                    <span className="hmg-tag">{t(MEDIA_KINDS.find((k) => k.value === item.kind).label)}</span>
                  )}
                  {!!HERO_POSITIONS.find((p) => p.value === item.position) && (
                    <span className="hmg-tag">{t(HERO_POSITIONS.find((p) => p.value === item.position).label)}</span>
                  )}
                </div>
              </div>

              {/* เปิด/ปิด แก้ไข ลบ : ต้องมีสิทธิ์แก้ไขหน้าแรก */}
              {can("homepage.update") && (
                <div className="hmg-row__actions">
                  <label className="ppl-switch" title={item.is_active ? t("home_hide") : t("home_show")}>
                    <input type="checkbox" checked={item.is_active} onChange={() => this.ToggleActive(item)} />
                    <span className="ppl-switch__track" />
                  </label>
                  <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} onClick={() => this.OpenEdit(item)}>
                    {ADMIN_ICON.edit}
                  </button>
                  <button
                    type="button"
                    className="prop-iconbtn icon"
                    style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                    title={t("delete")}
                    onClick={() => this.Delete(item)}
                  >
                    {ADMIN_ICON.trash}
                  </button>
                </div>
              )}
            </div>
          ))}

          {!list.length && (
            <div className="hmg-empty">
              <span className="icon">{ADMIN_ICON.image}</span>
              {t("home_empty_slide")}
            </div>
          )}
        </div>

        {/* ไม่มีสิทธิ์แก้ = ไม่ต้องมีแถบบันทึก ดูอย่างเดียว */}
        {can("homepage.update") && (
          <div className="ppl-savebar">
            {dirty ? (
              <span className="ppl-dirty">
                <span className="ppl-dirty__dot" />
                {t("unsaved_changes")}
              </span>
            ) : (
              <span className="text-secondary text-12 d-flex align-items-center gap-2">
                <span className="icon">{ADMIN_ICON.check}</span>
                {t("all_changes_saved")}
              </span>
            )}
            <div className="d-flex gap-2">
              <button type="button" className="prop-btn prop-btn--ghost" disabled={!dirty} onClick={this.Reset}>
                <span className="icon text-12">{ADMIN_ICON.reset}</span>
                {t("reset_changes")}
              </button>
              <button type="button" className="prop-btn" disabled={!dirty} onClick={this.Save}>
                <span className="icon text-12">{ADMIN_ICON.save}</span>
                {t("save_settings")}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  /* ======================================== render : แถบแคบตอนย่อรายการ */
  /* ย่อแล้วการ์ดรายการทั้งใบถูกแทนด้วยแถบนี้ ที่ว่างที่เหลือยกให้ตัวอย่างเว็บฝั่งขวา
     ยังมีของค้างไม่ได้บันทึกก็กดบันทึกจากตรงนี้ได้เลย ไม่ต้องขยายกลับก่อน */
  renderRail = () => {
    const list = ordered(this.state.slides);
    const dirty = this.isDirty();

    return (
      <div className="prop-card prop-in hmg-rail">
        <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("expand")} onClick={this.ToggleList}>
          {ADMIN_ICON.chevron_right}
        </button>
        <span className="hmg-rail__label">{t("home_hero_list_title")}</span>
        <span className="hmg-rail__count">
          {list.length} {t("home_unit_image")}
        </span>
        {dirty && can("homepage.update") && (
          <button type="button" className="prop-iconbtn icon hmg-rail__save" title={t("unsaved_changes")} onClick={this.Save}>
            {ADMIN_ICON.save}
          </button>
        )}
      </div>
    );
  };

  /* ==================================================== render : กล่องพรีวิว */
  renderPreview = () => {
    const list = this.activeSlides();
    const index = list.length ? this.state.preview % list.length : 0;
    /* ย่อรายการแล้ว = กล่องพรีวิวกางเต็มแถว ภาพจึงสูงขึ้นตามสัดส่วนหน้าเว็บจริง */
    const wide = !this.state.list_open;

    return (
      <div className="prop-card prop-in hmg-preview">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_preview")}
          </span>
          <a className="prop-link" href="/" target="_blank" rel="noreferrer">
            <span className="icon text-12">{ADMIN_ICON.external}</span>
            {t("home_open_site")}
          </a>
        </div>

        <div className="p-3">
          <div className="hmg-frame">
            <div className="hmg-frame__bar">
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__url">safespacelifeliving.com</span>
            </div>
            <div className="hmg-frame__body">
              <div className={`hmg-hero ${wide ? "is-wide" : ""}`}>
                {list.map((item, i) => (
                  <div className={`hmg-hero__slide ${i === index ? "is-active" : ""}`} key={item.uid}>
                    {item.src ? (
                      <img src={item.src} alt={item.name} style={{ objectPosition: item.position }} />
                    ) : (
                      <HomeMedia kind={item.kind} tone={item.tone} ratio={0.5} alt={item.name} />
                    )}
                  </div>
                ))}
                <span className="hmg-hero__veil" />

                <div className="hmg-hero__copy">
                  <div className="hmg-hero__title">
                    {t("home_hero_title_1")}
                    <span>{t("home_hero_title_2")}</span>
                  </div>
                </div>

                <div className="hmg-hero__search">
                  <span className="icon">{""}</span>
                  {t("home_opt_zone_any")}
                  <span className="hmg-hero__btn">{t("home_search_submit")}</span>
                </div>

                <div className="hmg-hero__dots">
                  {list.map((item, i) => (
                    <button
                      key={`dot-${item.uid}`}
                      type="button"
                      aria-label={item.name}
                      className={`hmg-hero__dot ${i === index ? "is-on" : ""}`}
                      onClick={() => this.setState({ preview: i })}
                    />
                  ))}
                </div>

                {!list.length && <div className="hmg-empty">{t("home_empty_slide")}</div>}
              </div>
            </div>
          </div>

          <div className="ppl-note mt-3">
            <span className="icon">{ADMIN_ICON.info}</span>
            <div>{t("home_hero_preview_hint")}</div>
          </div>
        </div>
      </div>
    );
  };

  /* ================================================== render : ฟอร์มเพิ่ม/แก้ */
  renderFormModal = () => {
    const { modal_form, edit_uid, form } = this.state;

    return (
      <Modal show={modal_form} onHide={this.CloseForm} size="lg" centered>
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("home_edit_image") : t("home_add_image")}</h5>
            <div className="text-secondary text-12">{t("home_hero_form_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          <div className="row g-3">
            {/* รูปที่จะใช้ */}
            <div className="col-md-6">
              <label className="prop-label">{t("home_image_file")}</label>
              <label className={`hmg-drop ${form.src ? "has-image" : ""}`}>
                <input type="file" accept="image/*" onChange={this.PickImage} />
                {form.src && <img src={form.src} alt="preview" style={{ objectPosition: form.position }} />}
                <span className="hmg-drop__tip">
                  <span className="icon">{ADMIN_ICON.photo}</span>
                  {form.src ? t("change_image") : t("home_pick_image")}
                </span>
              </label>
              <div className="ppl-sub mt-1">{t("home_image_hint")}</div>
              {!!form.src && (
                <button type="button" className="prop-link mt-2" onClick={() => this.setForm({ src: "" })}>
                  <span className="icon text-12">{ADMIN_ICON.trash}</span>
                  {t("home_remove_image")}
                </button>
              )}
            </div>

            {/* ภาพจำลอง — ใช้เมื่อยังไม่มีรูปจริง */}
            <div className="col-md-6">
              <label className="prop-label">{t("home_scene")}</label>
              <div className="hmg-thumb" style={{ width: "100%", height: "132px" }}>
                <HomeMedia kind={form.kind} tone={Number(form.tone)} ratio={0.5} />
              </div>
              <div className="ppl-sub mt-1">{form.src ? t("home_scene_ignored") : t("home_scene_hint")}</div>
            </div>

            <div className="col-12">
              <label className="prop-label">
                {t("home_slide_name")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="prop-field"
                maxLength={60}
                placeholder={t("home_slide_name_placeholder")}
                value={form.name}
                onChange={(e) => this.setForm({ name: e.target.value })}
              />
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("home_focus")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("select")}
                value={form.position}
                options={HERO_POSITIONS.map((item) => ({ value: item.value, label: t(item.label) }))}
                onChange={(value) => value && this.setForm({ position: value })}
              />
              <div className="ppl-sub mt-1">{t("home_focus_hint")}</div>
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("status")}</label>
              <div className="d-flex align-items-center gap-2" style={{ height: "44px" }}>
                <label className="ppl-switch">
                  <input type="checkbox" checked={form.is_active} onChange={(e) => this.setForm({ is_active: e.target.checked })} />
                  <span className="ppl-switch__track" />
                </label>
                <span className={`text-12 fw-bold ${form.is_active ? "text-success" : "text-secondary"}`}>
                  {form.is_active ? t("home_show") : t("home_hide")}
                </span>
              </div>
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_scene_kind")}</label>
              <div className="hmg-picker">
                {MEDIA_KINDS.map((item) => (
                  <button
                    key={item.value}
                    type="button"
                    className={`hmg-picker__kind ${form.kind === item.value ? "is-on" : ""}`}
                    onClick={() => this.setForm({ kind: item.value })}
                  >
                    {t(item.label)}
                  </button>
                ))}
              </div>
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_scene_tone")}</label>
              <div className="hmg-picker">
                {MEDIA_TONES.map((tone) => (
                  <button
                    key={tone}
                    type="button"
                    className={`hmg-picker__tone ${Number(form.tone) === tone ? "is-on" : ""}`}
                    title={`${t("home_scene_tone")} ${tone + 1}`}
                    onClick={() => this.setForm({ tone })}
                  >
                    <HomeMedia kind={form.kind} tone={tone} ratio={0.7} />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseForm}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.SaveSlide}>
            <span className="icon text-12">{ADMIN_ICON.check}</span>
            {t("confirm")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { updated_at, updated_by, list_open } = this.state;

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("home_hero_manage")}</h3>
              <div className="text-secondary text-14">{t("home_hero_manage_desc")}</div>
            </div>
            <div className="text-secondary text-12 text-lg-end">
              <div>
                {t("updated")} {format_date(updated_at, "dd mmm yyyy hh:mm", locale())}
              </div>
              <div>
                {t("updated_by")} {updated_by}
              </div>
            </div>
          </div>

          {/* ย่อแล้วรายการหดเป็นแถบแคบชิดซ้าย ที่เหลือเป็นของกล่องตัวอย่างเว็บทางขวา */}
          <div className="row g-3">
            <div className={list_open ? "col-xl-7 col-lg-7" : "col-auto"}>{list_open ? this.renderList() : this.renderRail()}</div>
            <div className={list_open ? "col-xl-5 col-lg-5" : "col"}>{this.renderPreview()}</div>
          </div>
        </div>

        {this.renderFormModal()}
      </div>
    );
  }
}
